module.exports = __webpack_public_path__ + "img/pic_location_Ecua_Guayaquil.8e4f9973.png";